export const version = 'v2.2.4-2057-g05258a1d4'
